if (!customElements.get('kimbia-gallery')) {
  customElements.define(
    'kimbia-gallery',
    class KimbiaGallery extends HTMLElement {
      connectedCallback() {
        this.mainImage = this.querySelector('[data-gallery-main]');
        this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.select(thumb));
        });
      }

      select(thumb) {
        if (!this.mainImage || thumb.getAttribute('aria-current') === 'true') return;

        this.thumbs.forEach((t) => t.setAttribute('aria-current', t === thumb ? 'true' : 'false'));

        const swap = () => {
          this.mainImage.srcset = thumb.dataset.srcset || '';
          this.mainImage.src = thumb.dataset.src;
          this.mainImage.alt = thumb.dataset.alt || '';
          this.mainImage.classList.remove('is-fading');
        };

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          swap();
          return;
        }

        this.mainImage.classList.add('is-fading');
        setTimeout(swap, 150);
      }
    }
  );
}
